import { gift } from "@/js/gifts.js";

export default {
    computed: {
        gift() {
            return gift
        },
    },
}
